import { useCallback } from 'react';
import { getBrowserInfo, getPublicKey, setDeviceIdInSession } from '@ibk/shared-auth';
import { ChannelEnum, DeviceTypeEnum, TemplateEnum } from '@ibk/shared-types';
import { useSaveDeviceMutation } from '../../services';
import { useAccountData } from './useAccountData';
export function useEmailValidation() {
    const { cpf, setDeviceId } = useAccountData();
    const [saveDevice, { isLoading }] = useSaveDeviceMutation();
    const handleSaveDevice = useCallback(async () => {
        if (!cpf) {
            throw new Error('CPF não encontrado');
        }
        const cleanDocumentNumber = cpf.replace(/\D/g, '');
        const publicKey = await getPublicKey();
        const { browserName, osName, osVersion } = getBrowserInfo();
        const deviceProps = {
            type: DeviceTypeEnum.phone,
            publicKey,
            make: osName,
            model: browserName,
            osVersion,
            channel: ChannelEnum.email,
            templateId: TemplateEnum.VALIDATION_TOKEN_TEMPLATE,
            documentNumber: cleanDocumentNumber,
        };
        const result = await saveDevice(deviceProps).unwrap();
        if (result?.result?.id) {
            const newDeviceId = result.result.id;
            setDeviceId(newDeviceId);
            setDeviceIdInSession(newDeviceId);
        }
        return result;
    }, [cpf, saveDevice, setDeviceId]);
    return {
        handleSaveDevice,
        isLoading,
    };
}
